import React from "react";
import { Pagination } from "zina-dogi-react";
import { utils } from "~/utils";
import PropTypes from "prop-types";

// Static constants outside component
const TITLES = ["ID", "TYPE", "STATE", "FILE", "START TIME", "END TIME"];

const computeRows = (list) => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((neo_importer, i) => {
            return (
                <tr key={`costpackage_${i}`} style={{ textAlign: "center" }}>
                    <td>{neo_importer.id}</td>
                    <td>{neo_importer.type}</td>
                    <td>{neo_importer.state}</td>
                    <td>
                        <a className="name" href={neo_importer.media_url}>
                            {neo_importer.original_filename}
                        </a>
                    </td>
                    <td>{utils.renderDate(neo_importer.start_execution_timestamp, "DD/MM/YYYY HH:ss")}</td>
                    <td>{utils.renderDate(neo_importer.finish_execution_timestamp, "DD/MM/YYYY HH:ss")}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={TITLES.length}>No data found</td>
            </tr>
        );
    }
};

const NeoImporterTable = ({ list, pagination, className, ...props }) => {
    const costpackageTable_op = { className: ["costpackage_table", className].join(" ") };
    return (
        <div {...costpackageTable_op}>
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {TITLES.map((title, index) => (
                                <th key={`cpo_title_${index}`} scope="col">
                                    {title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

NeoImporterTable.propTypes = {
    list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    pagination: PropTypes.object,
    className: PropTypes.string
};

export default NeoImporterTable;
